/**
 * Skeleton placeholder shown while a learning content item is loading
 * (e.g. a SCORM SCO loading inside its iframe). Mimics the shape of a content
 * page — title, meta, hero/media block and text lines — so the transition feels
 * smooth and consistent with the rest of the learner experience.
 */
export default function ContentSkeleton() {
  return (
    <div className="h-full w-full overflow-hidden bg-white p-6 lg:p-8 animate-pulse">
      {/* Title */}
      <div className="mb-6 h-7 w-2/3 rounded-md bg-gray-200" />

      {/* Meta row */}
      <div className="mb-8 flex gap-3">
        <div className="h-4 w-24 rounded bg-gray-200" />
        <div className="h-4 w-16 rounded bg-gray-200" />
      </div>

      {/* Hero / media block */}
      <div className="mb-8 h-56 w-full rounded-xl bg-gray-200 lg:h-64" />

      {/* Text lines */}
      <div className="space-y-3">
        <div className="h-4 w-full rounded bg-gray-200" />
        <div className="h-4 w-11/12 rounded bg-gray-200" />
        <div className="h-4 w-10/12 rounded bg-gray-200" />
        <div className="h-4 w-9/12 rounded bg-gray-200" />
        <div className="h-4 w-2/3 rounded bg-gray-200" />
      </div>
    </div>
  );
}
